/* src/app/components/control-module/form/dynamic-table/dynamic-table.component.css */
table {
  border-collapse: collapse;
  font-size: 14px;
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  border: 1px solid var(--border);
  background-color: var(--gray-50);
  padding: 5px;
  border-radius: 3px;
}
tr {
}
/*# sourceMappingURL=dynamic-table.component.css.map */
